import { Box, Stack, Tab, Tabs } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router-dom';

const tabs = [
  { to: '/admin/summary', label: 'Summary' },
  { to: '/admin/apps', label: 'Apps' },
  { to: '/admin/categories', label: 'Categories' },
  { to: '/admin/requests', label: 'Requests' },
  { to: '/admin/admins', label: 'Admins' },
  { to: '/admin/overrides', label: 'Overrides' },
  { to: '/admin/hr', label: 'HR Roster' },
  { to: '/admin/activity', label: 'Activity' },
];

export default function AdminLayout() {
  const loc = useLocation();
  const current = tabs.findIndex((t) => loc.pathname.startsWith(t.to));
  return (
    <Stack spacing={3}>
      <Tabs value={current === -1 ? 0 : current} variant="scrollable" allowScrollButtonsMobile>
        {tabs.map((t) => (
          <Tab key={t.to} label={t.label} component={Link} to={t.to} />
        ))}
      </Tabs>
      <Box>
        <Outlet />
      </Box>
    </Stack>
  );
}
